<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="facilities"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the application of a facility to a hotel by declaring how the hotel makes the facility
     * available - is it a site-wide facility shared between guests, or private to specific rooms
     */
    export default {
        name: 'ies-displaygroup',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                facilities: [{text: "On Site (shared between guests)", value: 1}, { text: "Unit Feature (private for all/specific rooms)", value: 2}, {text: "Both", value: 3}],
                viewValue: parseInt(this.field.value),
            }
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
